var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.634,
    height: 27.474,
    viewBox: "0 0 20.634 27.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_000000ff",
    "data-name": "#000000ff",
    transform: "translate(-63.921 0.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4161",
    "data-name": "Path 4161",
    d: "M64.791,0H76.672a.921.921,0,0,1,.595.288q3.485,3.625,6.967,7.252a.915.915,0,0,1,.269.7q0,9.116,0,18.232a.869.869,0,0,1-.82.907H64.792a.871.871,0,0,1-.724-.466,1.8,1.8,0,0,1-.1-.819V1.283a1.79,1.79,0,0,1,.1-.819A.872.872,0,0,1,64.791,0m.891,1.711V25.664H82.791V9.41c-2.282,0-4.565,0-6.847,0a.858.858,0,0,1-.85-.85c-.005-2.282,0-4.564,0-6.847h-9.41M76.8,2.277q0,2.712,0,5.423h5.212Z",
    transform: "translate(0)",
    stroke: "#000",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4162",
    "data-name": "Path 4162",
    d: "M130.5,304.125a4.542,4.542,0,0,1,1.646.106c.351.065.374.479.367.764a.419.419,0,0,1-.485.382,6.9,6.9,0,0,0-.853-.2,1.724,1.724,0,0,0-1.381.416,2.2,2.2,0,0,0-.565,1.589,2.093,2.093,0,0,0,.414,1.317,1.486,1.486,0,0,0,1.1.481,3.307,3.307,0,0,0,1.123-.2.446.446,0,0,1,.527.163.788.788,0,0,1,.025.567.432.432,0,0,1-.277.363,3.937,3.937,0,0,1-2.216.048,2.429,2.429,0,0,1-1.676-1.779,3.865,3.865,0,0,1,.013-1.986,2.594,2.594,0,0,1,1.107-1.631A2.841,2.841,0,0,1,130.5,304.125Z",
    transform: "translate(-60.731 -287.834)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4163",
    "data-name": "Path 4163",
    d: "M220.461,304.076a3.905,3.905,0,0,1,1.209.115c.283.089.3.426.308.673a.424.424,0,0,1-.5.446,3.171,3.171,0,0,0-.86-.16.43.43,0,0,0-.35.76c.414.476.9.884,1.331,1.342a1.781,1.781,0,0,1,.525,1.093,1.467,1.467,0,0,1-.726,1.465,2.74,2.74,0,0,1-2.312-.044c-.253-.125-.234-.44-.24-.678a.426.426,0,0,1,.487-.442c.189.044.354.152.538.212a1.308,1.308,0,0,0,.924.03.414.414,0,0,0,.156-.614c-.488-.661-1.214-1.106-1.679-1.786a1.538,1.538,0,0,1,1.192-2.411Z",
    transform: "translate(-146.592 -287.81)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4164",
    "data-name": "Path 4164",
    d: "M287.86,305.5c.148-.15.372-.1.56-.1a.418.418,0,0,1,.418.3c.364,1.244.784,2.47,1.181,3.7q.784-1.691,1.557-3.389c.106-.219.159-.53.431-.6a2.113,2.113,0,0,1,.533,0,.431.431,0,0,1,.275.607c-.771,1.61-1.542,3.22-2.259,4.855a.491.491,0,0,1-.369.347,2.5,2.5,0,0,1-.529,0,.454.454,0,0,1-.346-.357c-.479-1.63-1.045-3.232-1.567-4.848A.458.458,0,0,1,287.86,305.5Z",
    transform: "translate(-211.78 -289.066)",
    stroke: "#000",
    strokeWidth: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/Clipboard.6d20edfb261623c45b32a135e82bf2b9.svg";
export { ForwardRef as ReactComponent };